import type { CityOrderReview } from "../../../api/cityOrders";
import { formatMoney, fromCents } from "../../../api/money";
import CheckTable from "./CheckTable";
import { totalAfterCents, type Choice, type Choices } from "./cityOrderReview";

interface Props {
  review: CityOrderReview;
  choices: Choices;
  onChoose: (code: string, choice: Choice | null) => void;
}

/** Step 3: decide each difference, with our BOQ's total as it would stand. */
export default function ClearStep({ review, choices, onChoose }: Props) {
  return (
    <>
      <p className="cm-doc-note">Decide each difference: use the City's figure, which corrects our BOQ, or keep ours and say why.</p>
      <CheckTable lines={review.lines} choices={choices} onChoose={onChoose} editable />
      <p className="cm-doc-note">
        Our BOQ after your decisions: {formatMoney(fromCents(totalAfterCents(review, choices)))} · The City's PO: {formatMoney(review.totals.city_excl_vat)}
      </p>
    </>
  );
}
